import { defineComponent as _defineComponent } from 'vue'
import { Beneficiary } from 'ah-api-gateways';
import AddressInfo from '../address/AddressInfo.vue';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';
import { lastIbanDigits, maskedIban } from 'ah-common-lib/src/helpers/iban';
import { useBeneficiariesState } from 'ah-beneficiaries';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountInfo',
  props: {
    hideHeader: { type: [Boolean, String], default: true },
    beneficiary: null,
    simple: { type: [Boolean, String], default: false }
  },
  setup(__props: any) {

const props = __props as { hideHeader: boolean | string, beneficiary: Beneficiary, simple: boolean | string };



const beneficiarieState = useBeneficiariesState();

loadRoutingCodeTypes();

function loadRoutingCodeTypes() {
  beneficiarieState.store.useSettingsStore().loadRoutingCodeTypes();
}

const accountRoutingCode = computed(() => {
  const routingData = beneficiarieState.store
    .useSettingsStore()
    .routingCodes.find((r) => r.currency === props.beneficiary.currency);
  if (routingData) {
    return routingData.title;
  }
  return 'Routing Code';
});

const withHeader = computed(() => {
  return props.hideHeader !== true;
});

return { __sfc: true,props, beneficiarieState, loadRoutingCodeTypes, accountRoutingCode, withHeader, AddressInfo, countryNameFromCC, lastIbanDigits, maskedIban }
}

})